import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { PaginatedListOfUserImpersonatedWithPaginationDto } from '../../../../core/api/models/paginated-list-of-user-impersonated-with-pagination-dto';
import { FormPageConfig } from '../../../../core/models/form-page-config.model';
import { BaseIndexPageComponent } from '../../../shared/base/components/base-index-page.component';
import { Device } from './../../../../core/api/models/device';
import { UserImpersonatedByIdDto } from './../../../../core/api/models/user-impersonated-by-id-dto';
import { UserImpersonatedWithPaginationDto } from './../../../../core/api/models/user-impersonated-with-pagination-dto';
import { AccountService } from './../../../../core/api/services/account.service';

@Component({
  selector: 'app-user-impersonated',
  templateUrl: './user-impersonated.component.html',
  imports: [BaseIndexModule],
})
export class UserImpersonatedComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.userImpersonated;
  protected currentService = inject(AccountService);
  paginationApiMethodName: string =
    this.currentService.accountGetUserImpersonatedWithPagination.name;

  modelWithPagination$: Observable<PaginatedListOfUserImpersonatedWithPaginationDto>;
  items$: Observable<Array<UserImpersonatedWithPaginationDto>>;
  formPageConfig: FormPageConfig<UserImpersonatedByIdDto> = {};

  get Device() {
    return Device;
  }

  //#endregion

  constructor() {
    super();
  }
  ngOnInit() {
    super.ngOnInit();
    this.pageConfig.showAuditBtn = false;
    this.pageConfig.showAddBtn = false;
    this.pageConfig.tableConfig.showOperationColumn = false;
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: `${this.tableVocabs}impersonatorUserName`,
        name: 'impersonatorUserName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}impersonatedUserName`,
        name: 'impersonatedUserName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}impersonatorOrganizationName`,
        name: 'impersonatorOrganizationName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}impersonatedOrganizationName`,
        name: 'impersonatedOrganizationName',
        hasSearch: true,
        wrap: true,
      },

      {
        title: 'common.ipAddress',
        name: 'ipAddress',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `common.browser`,
        name: 'browser',
        hasSearch: true,
        type: 'enum',
        enumName: 'Browser',
        wrap: true,
      },
      {
        title: `common.device`,
        name: 'device',
        hasSearch: true,
        type: 'enum',
        enumName: 'Device',
        wrap: true,
      },
      {
        title: `common.os`,
        name: 'os',
        hasSearch: true,
        type: 'enum',
        enumName: 'Platform',
        wrap: true,
      },
      { title: 'common.signInSignOut', name: 'isSignOut', wrap: true },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
        wrap: true,
      },
    ];
  }

  //#region Api
}
